export default {
  maintenaceSlogan: 'Chúng tôi sẽ trở lại sớm!',
  maintenanceMessage:
    'Chúng tôi hiện đang thực hiện bảo trì định kỳ để cải thiện dịch vụ cho bạn. Chúng tôi xin lỗi vì sự bất tiện này và đánh giá cao sự kiên nhẫn của bạn. Vui lòng kiểm tra lại sau',
  maintenanceAction: 'Cần hỗ trợ?',
  linkToDiscord: 'Liên hệ với đội ngũ hỗ trợ của chúng tôi',
}
